import { render, staticRenderFns } from "./importDataPeserta.vue?vue&type=template&id=d1c98c3c&"
import script from "./importDataPeserta.vue?vue&type=script&lang=js&"
export * from "./importDataPeserta.vue?vue&type=script&lang=js&"
import style0 from "./importDataPeserta.vue?vue&type=style&index=0&id=d1c98c3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports